import React, { createContext, ReactNode, useContext, useState } from 'react';

interface SidebarContextType {
  activeTitle: string;
  setActiveTitle: (title: string) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const useDashboardSidebarProvider = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) throw new Error('useSidebar must be used within a SidebarProvider');
  return context;
};

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [activeTitle, setActiveTitle] = useState('Dashboard');

  return <SidebarContext.Provider value={{ activeTitle, setActiveTitle }}>{children}</SidebarContext.Provider>;
};
